import { render, staticRenderFns } from "./planos.vue?vue&type=template&id=79810e54&"
import script from "./planos.vue?vue&type=script&lang=js&"
export * from "./planos.vue?vue&type=script&lang=js&"
import style0 from "./planos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports